import React, { useEffect } from "react";
import Card from "../CommonComponents/Card";
import LeftPart from "./LeftPart";
import PostLoginView from "./PostLoginView";
import PreLoginView from "./PreLoginView";
import RightPart from "./RightPart";
import toastr from "toastr";

import style from "./style.module.css";

const Header = ({
  login,
  setShow,
  appLogin = false,
  isPwaOpen,
  notifications = [],
}) => {
  useEffect(() => {
    toastr.options.preventDuplicates = true;
  }, []);
  return (
    <>
      <Card
        className={`${
          appLogin ? style["appLoginHeight"] : style["newHeaderHeight"]
        } ${style["borderbackground"]} padding16`}
      >
        <div
          className={`d-flex padding-top4 padding-bottom4 margin-bottom16 align-items-center`}
        >
          <div className="flex50">
            <LeftPart login={login} appLogin={appLogin} />
          </div>

          <div>
            <RightPart login={login} notifications={notifications} />
          </div>
        </div>
      </Card>

      {login && !appLogin ? (
        <PostLoginView isPwaOpen={isPwaOpen} notifications={notifications} />
      ) : !appLogin ? (
        <PreLoginView setShow={setShow} isPwaOpen={isPwaOpen} />
      ) : (
        ""
      )}
    </>
  );
};
export default Header;
